// extracted by mini-css-extract-plugin
export default {"selector":"LangSwitcher_selector__QBjJd","label":"LangSwitcher_label__7ZZG7","content":"LangSwitcher_content__O7LGk","placeHolderShimmer":"LangSwitcher_placeHolderShimmer__qCo0s"};